module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#rss",
      toString: function () {
        return this.url;
      }
    }